import React from 'react'
import CustomHeaderNavigation from './CustomHeaderNavigation'
import moment from 'moment'
import styles from './datePickerWtn.module.scss'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'

const MonthPickerHeader = ({
  monthDate,
  decreaseYear,
  increaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => (
  <CustomHeaderNavigation
    className={styles.monthPickerHeader}
    config={{
      prev: { disabled: prevYearButtonDisabled, onClick: decreaseYear },
      next: { disabled: nextYearButtonDisabled, onClick: increaseYear },
    }}
  >
    <div className={styles.label}>{moment(monthDate).format('YYYY')}</div>
  </CustomHeaderNavigation>
)

export default MonthPickerHeader
